import angular from 'angular';
import { clientChooserComponent } from './clientChooserComponent';
import { ClientChooserWhitelistService } from './whitelist/ClientChooserWhitelistService';
import 'components/sharpr/identity/identityModule';
import 'components/sharpr/cfg/cfgModule';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/theme/themeModule';
import 'components/sharpr/typeahead/select/typeaheadSelectModule';
import 'components/sharpr/onOutsideClick/onOutsideClickModule';

// Cfg, Api, Theme, $state, PartnerLinks
angular
	.module('sh.clientChooser', ['sh.identity', 'sh.cfg', 'sh.api', 'sh.theme', 'sh.typeaheadSelect', 'sh.onOutsideClick'])
	.service('ClientChooserWhitelist', ClientChooserWhitelistService)
	.component('shClientChooser', clientChooserComponent());
